import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/constants/faq";

export const FaqAccordion = () => {
  return (
    <section data-testid="faq-list" className="bg-white">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map(({ question, answer, testId }) => (
            <AccordionItem key={testId} value={testId} data-testid={testId} className="border-[#E2E8F0]">
              <AccordionTrigger
                data-testid={`${testId}-question`}
                className="text-base sm:text-lg font-semibold text-[#042D1F] hover:no-underline py-5 gap-3"
              >
                <span className="flex items-start gap-3 text-left">
                  <HelpCircle className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
                  {question}
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`${testId}-answer`}
                className="text-sm sm:text-base text-slate-600 leading-relaxed pl-8"
              >
                {answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
